import { useContext, useEffect, useState } from "react";
import { LogOut } from "react-feather";
import { deleteCookie } from "../../Components/authorization";

//MUI
import { Pencil, Warning } from "phosphor-react";
//css
import { MovieColabContext } from "../../Context/MovieColabContext";
import { unregisterDevice } from "../Fcm/firebaseInit";
import useStyles from "./ProfileDropdown.styles";
import { Modal } from "@material-ui/core";
import EditProfileModal from "./EditProfileModal";

function ProfileDropdown(props) {
  const classes = useStyles();
  const APP_BASE_URL = process.env.REACT_APP_BASE_URL_MCF.split("/")[2];
  const DOMAIN_TYPE = process.env.REACT_APP_DOMAIN_TYPE;
  const APP_URL = window.location.href;
  const redirectParams = `?type=${DOMAIN_TYPE}&baseUrl=${APP_BASE_URL}&redirectUrl=${APP_URL?.replace(
    /^https?:\/\//,
    ""
  )}`;
  const SSO_URL_FRONTEND = process.env.REACT_APP_BASE_URL_SSOF;
  const [onState, setOnState] = useState(true);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
  const { loggedInUser } = useContext(MovieColabContext);

  useEffect(() => {
    if (
      localStorage.getItem("theme") === null ||
      localStorage.getItem("theme") === "dark"
    )
      setOnState(true);
    else setOnState(false);
  }, []);

  const logOut = () => {
    unregisterDevice();
    localStorage.removeItem("notifications");
    deleteCookie("access");
    deleteCookie("refresh");
    // window.location.href = SSO_URL_FRONTEND + "/login/" + redirectParams;
    window.location.href = "/login/";
  };

  const handleProfileChange = () => {
    window.location.href = SSO_URL_FRONTEND + "editprofile";
  };

  return (
    <div className={classes.profileDropdown}>
      {/* <div class={classes.popoverArrow}></div> */}
      <div className={classes.profileDropdownMenu}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            backgroundColor: "#1C1E29",
            padding: "10px",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          {loggedInUser?.avatar ?
            <img src={loggedInUser?.avatar} alt="avatar" className={classes.userNameAvatar} /> :
            <div className={classes.userNameAvatar}>
              {loggedInUser?.first_name?.charAt(0).toUpperCase() ?? ""}
              {loggedInUser?.last_name?.charAt(0).toUpperCase() ?? ""}
            </div>
          }
          <div
            style={{
              width: "80%",
              overflow: "hidden",
              textAlign: "start",
            }}
          >
            <div>
              {loggedInUser?.first_name} {loggedInUser?.last_name}
            </div>{" "}
            <div>{loggedInUser?.email}</div>
          </div>
        </div>

        {/* <Divider /> */}
        <div
          className={classes.profileDropdownItems}
          onClick={() => {
            setIsEditProfileModalOpen(true);
            // props.handleClose();
          }}
        >
          <span>
            <Pencil size={20} />
          </span>
          <p>Edit Profile</p>
        </div>
        <div
          className={classes.profileDropdownItems}
          onClick={() => window.open("/reports", "_blank")}
        >
          <span>
            <Warning size={20} />
          </span>
          <p>Report An Issue</p>
        </div>
        {/* <div className={classes.profileDropdownItems}>
          <div>
            <Sun size={26} />
          </div>
          <div>
            <Switch
              height={20}
              width={40}
              offColor={"#171B21"}
              onColor={"#4ECCA3"}
              checked={onState}
              onClick={props.themeToggler}
              onChange={() => setOnState(!onState)}
            />
          </div>
          <div>
            <MoonStars size={26} />
          </div>
        </div> */}
        {/* <Divider style={{ marginTop: "10px" }} /> */}
        <div
          className={classes.profileDropdownItems}
          onClick={(e) => {
            e.preventDefault();
            logOut();
          }}
        >
          <LogOut />
          <p>Log Out</p>
        </div>
      </div>
      <Modal
        open={isEditProfileModalOpen}
        onClose={() => setIsEditProfileModalOpen(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EditProfileModal
          handleClose={() => setIsEditProfileModalOpen(false)}
        />
      </Modal>
    </div>
  );
}

export default ProfileDropdown;
